module.exports = __webpack_public_path__ + "img/6.1b8a8989.svg";